import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCbHNi_A_suxGff7r14PDTr-BNwL7J0C8o",
  authDomain: "myfirebase-be46b.firebaseapp.com",
  projectId: "myfirebase-be46b",
  storageBucket: "myfirebase-be46b.appspot.com",
  messagingSenderId: "332842456289",
  appId: "1:332842456289:web:2b0e4acfc76f10fab093a0",
  measurementId: "G-QXTB042YQR",
};

initializeApp(firebaseConfig);

const messaging = getMessaging();

const publicKey =
  "BI43bxLnB25uHwnnVBkBDxzJb1oGM8CvBjU0CrQ60UG3Z_zF05DIuxuRcrqFfqtdSDjC9iJxOgDzO4G-dgNZYMQ";

export const requestForToken = async (setTokenFound) => {
  return getToken(messaging, { vapidKey: publicKey })
    .then((currentToken) => {
      if (currentToken) {
        setTokenFound(true);
        console.log("current token for client: ", currentToken);
        // Perform any other neccessary action with the token
      } else {
        setTokenFound(false);
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("payload", payload);
      // resolve(payload);
    });
  });
